import Campaigns from './campaigns'
import secretDesignId from './secretDesignId'

const Designs = { Campaigns, secretDesignId }

export default Designs;
